import axios from 'axios'
import {URL} from '../../util/ambienteActions';
import {LISTAR_FILTROS_BAGAGEM} from '../types';

export default function listarFiltrosBagagem() {
    const url = `${URL}/cupom/filtros`;

    return dispatch => axios.get(url).then(
        response => dispatch({
            type: LISTAR_FILTROS_BAGAGEM,
            payload: response

        })
    );
}
